export const commonChartMargins = { top: 5, right: 30, left: 20, bottom: 24 }
